module.exports = __webpack_public_path__ + "static/coach-hire-services-community-groups-f81583e2fcc854a654034cd53c1d9a36.jpg";